import { makeStyles } from '@material-ui/core';

/* eslint-disable import/prefer-default-export */
export const useSettingsStyles = makeStyles(theme => ({
    active: {
        borderLeft: `3px solid ${theme.palette.primary.main}`,
        color: `${theme.palette.primary.main}`,
    },
    inActive: {
        borderLeft: `3px solid transparent`,
        color: `${theme.palette.text.primary}`,
        '&:hover': {
            color: `${theme.palette.primary.main}`,
        },
    },
    withChevron: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));
